import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';

@Component({
  selector: 'statistics',
  standalone: true,
  imports: [],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.scss'
})
export class StatisticsComponent implements AfterViewInit {
  @ViewChild('mixpanel') mixpanel?: ElementRef

  ngAfterViewInit(): void {
    let iframe = this.mixpanel?.nativeElement as HTMLIFrameElement
    iframe.onload = () => {
      iframe.style.height = '92vh'
    }
  }

}
